import { EventModel } from 'features/events/EventModel';
import { Broadcast } from 'features/broadcast/broadcastsSlice';
import dayjs, { Dayjs } from 'utilities/dayjs';

export const startTimeChecker = (
  event: EventModel,
  broadcast: Broadcast | null
): Dayjs | null => {
  if (broadcast && broadcast.startedAt) {
    return dayjs(broadcast.startedAt).tz(event.timezone);
  }

  return event.parsedStartedAt
    ? event.parsedStartedAt
    : event.parsedStartsAt || null;
};
